import React from 'react';
import { DescriptionContentWrapper } from './style';

const ContentDescription = ({ children }) => <DescriptionContentWrapper>{children}</DescriptionContentWrapper>;

export default ContentDescription;
